
import barba from '@barba/core';

export default class{

	constructor(){
        this.area = '.js-area__shop'
        barba.hooks.afterOnce((data) => {
            this.init()
        })
        barba.hooks.after((data) => {
            this.init()
        });
    }
    // init(){
    //     const area = document.querySelector(this.area);
    //     if(area) {
    //         const options = {
    //             root: null,
    //             rootMargin: "0px 0px",
    //             threshold: 0
    //         };
    //         const observer = new IntersectionObserver((entries) => {
    //             for(const e of entries) {
    //                 console.log(e);
    //                 const header = document.querySelector('#l-header__fixed');
    
    //                 // if (area.classList.contains('is-nagoya')) {
    //                 //     // const innerHeight = area.clientHeight;
    //                 //     // const y = window.pageYOffset;
    //                 //     // const rect = area.getBoundingClientRect();
    //                 //     // const top = rect.top;
    //                 //     // const bottom = rect.bottom + innerHeight;
    //                 //     // if( y > top && y < bottom ) {
    //                 //     //     header.classList.add('is-nagoya')
    //                 //     // } else if( y > bottom ) {
    //                 //     //     header.classList.remove('is-nagoya')
    //                 //     // } else if( y < top ) {
    //                 //     //     header.classList.remove('is-nagoya')
    //                 //     // }
    //                 //     header.classList.add('is-nagoya')
    //                 // } else {
    //                 //     header.classList.remove('is-nagoya')
    //                 // }
    //                 if (e.isIntersecting) {
    //                     header.classList.add('is-nagoya')
    //                 } else {
    //                     header.classList.remove('is-nagoya')
    //                 }
    //             }
    //         }, options);
    //         observer.observe(document.getElementById('shop'));
    //     }
    //     // const observer = newIntersectionObserver(doWhenIntersect, options);
	// 	// areas.forEach(area => {
    //     //     observer.observe(area);
    //     // });
    // }

//     /**
//      * 交差したときに呼び出す関数
//      * @param entries
//      */
//     doWhenIntersect(entries) {
//         // 交差検知をしたもののなかで、isIntersectingがtrueのDOMを色を変える関数に渡す
//         entries.forEach(entry => {
//             if (entry.isIntersecting) {
//                 activateHeader(entry.target);
//             }
//         });
//     }

//     /**
//      * 関数
//      * @param element
//      */
//     activateHeader(element) {
//     // すでにアクティブになっている目次を選択
//     const header = document.querySelector('#l-header__fixed');
//     const activeNagoya = document.querySelector(".js-area__shop.is-nagoya");
//     // すでにアクティブになっているものが0個の時（=null）以外は、activeクラスを除去

//     if (activeNagoya) {
//         let innerHeight = activeNagoya.clientHeight;
//         let y = window.pageYOffset;
//         let rect = activeNagoya.getBoundingClientRect();
//         let top = rect.top;
//         let bottom = rect.bottom + innerHeight;
//         if( y > top && y < bottom ) {
//             header.classList.add('is-nagoya')
//         } else {
//             header.classList.remove('is-nagoya')
//         }
//         // console.log(top)
//         // console.log(bottom)
//         // console.log(window)
//         // console.log(rect)
//     }
//   }

    init() {
        const area = document.querySelector(this.area);
        if(area) {
            window.addEventListener('scroll', (e) => {
                this.handleEffect(e);
            })
        }
    }
    handleEffect() { 
        const target = document.querySelector(this.area);
        const header = document.querySelector('#l-header');
        const hamburger = document.querySelector('#js-hamburger');
        if(target && target.classList.contains('is-nagoya')) {
            // header.classList.add('is-nagoya');
            let t_height = target.offsetHeight;
            let h_height = header.clientHeight;
            let offsetY = target.getBoundingClientRect().top - h_height;
            let screenHeight = window.outerHeight;
            let t_position = offsetY - screenHeight;

            // console.log(2*h_height);
            // console.log(t_position);
            // console.log(t_position);

            if(-screenHeight <= (t_position + t_height) && offsetY < 0) {
                header.classList.add('is-nagoya__active');
                hamburger.classList.add('is-nagoya__active');
            } else {
                header.classList.remove('is-nagoya__active');
                hamburger.classList.remove('is-nagoya__active');
            }
        }
    }
}